import {
    ATENCION_REQUEST,
    ATENCION_SUCCESS,
    ATENCION_FAILURE,
    SET_ATENCION_ACTIVA,
    CLEAR_ATENCION_ACTIVA,
    UPDATE_ATENCION_ITEMS,
    SET_SESIONES_ATENCION,
    UPDATE_SESION_LOCAL,
} from "./atencionesTypes";

const initialState = {
    loading: false,
    error: "",
    atencionActiva: null,
    sesiones: [], // Executions for today
};

export const atencionesReducers = (state = initialState, action) => {
    switch (action.type) {
        case ATENCION_REQUEST:
            return { ...state, loading: true };
        case ATENCION_SUCCESS:
            return { ...state, loading: false, error: "" };
        case ATENCION_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SET_ATENCION_ACTIVA:
            return { ...state, atencionActiva: action.payload };
        case UPDATE_ATENCION_ITEMS:
            return {
                ...state,
                atencionActiva: {
                    ...state.atencionActiva,
                    items: action.payload
                }
            };
        case SET_SESIONES_ATENCION:
            return { ...state, sesiones: action.payload };
        case UPDATE_SESION_LOCAL:
            return {
                ...state,
                sesiones: state.sesiones.map(s =>
                    s.id === action.payload.sesionId
                        ? { ...s, ...action.payload.data }
                        : s
                )
            };
        case CLEAR_ATENCION_ACTIVA:
            return { ...state, atencionActiva: null, sesiones: [] };
        default:
            return state;
    }
};
